export const dash = "–";

export function fmtPct(v: number | null | undefined, digits = 0): string {
	return v === null || v === undefined || !Number.isFinite(v)
		? dash
		: `${(v * 100).toFixed(digits)}%`;
}

/** Signed percentage points, e.g. +4.9pp. For edge, which is a difference of probabilities. */
export function fmtPp(v: number | null | undefined): string {
	if (v === null || v === undefined || !Number.isFinite(v)) return dash;
	const txt = (v * 100).toFixed(1);
	if (Number(txt) === 0) return "0.0pp"; // no "-0.0pp"
	return `${Number(txt) > 0 ? "+" : ""}${txt}pp`;
}

/** Signed return per $1 staked, e.g. +18% / -94%. */
export function fmtRoi(v: number | null | undefined): string {
	if (v === null || v === undefined || !Number.isFinite(v)) return dash;
	const txt = (v * 100).toFixed(Math.abs(v * 100) >= 100 ? 0 : 1);
	if (Number(txt) === 0) return "0.0%";
	return `${Number(txt) > 0 ? "+" : ""}${txt}%`;
}

export function fmtCents(v: number | null | undefined): string {
	return v === null || v === undefined || !Number.isFinite(v)
		? dash
		: `${(v * 100).toFixed(0)}¢`;
}

export function fmtUsd(v: number | null | undefined): string {
	if (v === null || v === undefined || !Number.isFinite(v)) return dash;
	const abs = Math.abs(v);
	const sign = v < 0 ? "-" : "";
	if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
	if (abs >= 10_000) return `${sign}$${(abs / 1_000).toFixed(0)}k`;
	if (abs >= 1_000) return `${sign}$${(abs / 1_000).toFixed(1)}k`;
	return `${sign}$${abs.toFixed(0)}`;
}

export function fmtNum(v: number | null | undefined, digits = 2): string {
	return v === null || v === undefined || !Number.isFinite(v)
		? dash
		: v.toFixed(digits);
}

export function shortAddr(a: string | null | undefined): string {
	if (!a) return dash;
	return a.length > 12 ? `${a.slice(0, 6)}…${a.slice(-4)}` : a;
}

/** Colour class for a signed value: green > 0, red < 0, neutral when missing or ~0. */
export function signClass(v: number | null | undefined, eps = 1e-9): string {
	if (v === null || v === undefined || !Number.isFinite(v)) return "text-mute";
	if (v > eps) return "text-up";
	if (v < -eps) return "text-dn";
	return "text-dim";
}

/** Brier: lower is better. 0.25 is a coin-flip forecaster, so colour relative to that. */
export function brierClass(v: number | null | undefined): string {
	if (v === null || v === undefined || !Number.isFinite(v)) return "text-mute";
	if (v < 0.15) return "text-up";
	if (v > 0.25) return "text-dn";
	return "text-fg";
}

/** Compact count for profile views: 84, 1.1K, 12K. */
export function fmtViews(v: number | null | undefined): string {
	if (v === null || v === undefined || !Number.isFinite(v)) return dash;
	if (v >= 10_000) return `${Math.round(v / 1000)}K`;
	if (v >= 1_000) return `${(v / 1000).toFixed(1)}K`;
	return String(v);
}

export const profileUrl = (addr: string) => `https://polymarket.com/profile/${addr}`;
